import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_02, PROMETHEAN_TYPOGRAPHY_BODY } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_DARK_PLUM, PROMETHEAN_NEUTRAL_LIGHT_GREY } from '../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersUpload';
export var UploadContainer = styled('div')(_defineProperty({
  height: '100%'
}, ".".concat(ROOT_PREFIX), {
  height: 'inherit',
  padding: '24px',
  display: 'flex',
  justifyContent: 'center',
  touchAction: 'manipulation',
  input: {
    display: 'none'
  },
  '&-customDisplay': {
    padding: 0
  },
  // eslint-disable-next-line quotes
  backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%239955C6FF' stroke-width='1' stroke-dasharray='8%2c4' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
  '&-active': {
    backgroundColor: PROMETHEAN_NEUTRAL_LIGHT_GREY
  },
  '&-content': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '14px',
    minHeight: '96px',
    '&-init': {
      flexDirection: 'column',
      i: {
        fontSize: '72px',
        color: PROMETHEAN_NEUTRAL_DARK_PLUM
      },
      '.EmbersLink': {
        fontSize: 'inherit',
        letterSpacing: 'inherit'
      }
    },
    '&-success': {
      flexDirection: 'column',
      rowGap: '8px',
      div: {
        display: 'flex',
        columnGap: 16
      },
      '.EmbersStatusIcon-icon.upload-status-icon': {
        fontSize: 48
      },
      '.success-area': {
        alignItems: 'center',
        '.EmbersInteractiveIcon-root': {
          marginTop: -5,
          marginBottom: -5
        }
      }
    },
    '&-error': {
      '.EmbersStatusIcon-icon.upload-status-icon': {
        fontSize: 72
      },
      '.error-content': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY)
    }
  })
}));